module.exports = __webpack_public_path__ + "img/-LV18Qv5Vzax98R0IJ5y.a073a040.jpg";